import React from 'react';

import tutorQ from '@/assets/images/ai-tutor/tutor-q.png';

interface TutorChatHeaderProps {
	title: string;
	minimiseChat: () => void;
}
const TutorChatHeader = ({ title, minimiseChat }: TutorChatHeaderProps) => {
	return (
		<div className="ai-tutor__header">
			<div className="ai-tutor__header-avatar">
				<img src={tutorQ} alt="squla-q" />
			</div>
			<div className="ai-tutor__header-content">{title}</div>
			<div className="ai-tutor__header-action">
				<button type="button" onClick={minimiseChat} aria-label="Minimaliseer chat">
					<span
						className="ai-tutor__icon ai-tutor__icon--large icon-chevron-down"
						aria-hidden="true"
					/>
				</button>
			</div>
		</div>
	);
};

export default TutorChatHeader;
